import { endOfDay, startOfDay, subDays } from "date-fns";

import type { MetricsQueryParams } from "src/analytics/metrics/useMetricsQuery";
import type { Pin } from "src/clients/analytics-dashboard";
import type { Environment } from "src/hooks/useEnvironment";
import type { StrictDateRange } from "src/utils/timeWindow";

const DEFAULT_WINDOW_DAYS = 30;

export const defaultDashboardWindow = (): StrictDateRange => ({
  from: startOfDay(subDays(new Date(), DEFAULT_WINDOW_DAYS)),
  to: endOfDay(new Date()),
});

export const buildPinQueryParams = (
  parameterNames: string[] | undefined,
  environment: Environment,
  timeWindow: StrictDateRange,
): MetricsQueryParams | undefined => {
  if (!parameterNames || parameterNames.length === 0) {
    return undefined;
  }
  const available: MetricsQueryParams = {
    environment: [environment],
    time_range_start: timeWindow.from.toISOString(),
    time_range_end: timeWindow.to.toISOString(),
  };
  return Object.fromEntries(
    parameterNames
      .filter((name) => name in available)
      .map((name) => [name, available[name]]),
  );
};

export type PinBatchedQuery = { sql: string; params?: MetricsQueryParams };

export const buildPinBatchedQueries = (
  pins: Pin[],
  environment: Environment,
  timeWindow: StrictDateRange,
): Record<string, PinBatchedQuery> =>
  Object.fromEntries(
    pins.map((pin) => {
      const params = buildPinQueryParams(
        pin.definition.query.parameters,
        environment,
        timeWindow,
      );
      const sql = pin.definition.query.query;
      return [pin.id, params ? { sql, params } : { sql }];
    }),
  );
